import { useCPQPriceCalculator } from '@shared/composables/useCPQPriceCalculator';
import { applyProductVolumeAdjustment } from '@shared/utils/volumePricingRules';

/**
 * Pricing snapshot sent with a configured product. The API treats its unit
 * price as authoritative and logs drift against its own calculation.
 * KEEP IN SYNC with frontendPricing in smartflow-api
 * services/productPricingService.js (calculateConfiguredProductPricing) and
 * utils/pricingDrift.js.
 */
export function buildConfiguredPricingSnapshot(cpqResult, product, configuration = {}) {
  if (!cpqResult) return null;
  const upsellsPrice = cpqResult.upsellsPrice || 0;
  const totalPrice = cpqResult.totalPrice || 0;
  return applyProductVolumeAdjustment(product, configuration, {
    basePrice: cpqResult.basePrice || 0,
    matrixPrice: cpqResult.matrixPrice || 0,
    optionsPrice: cpqResult.optionsPrice || 0,
    autoIncludePrice: cpqResult.autoIncludePrice || 0,
    crossOptionRulesPrice: cpqResult.crossOptionRulesPrice || 0,
    totalPrice,
    productOnlyPrice: cpqResult.productOnlyPrice ?? totalPrice - upsellsPrice,
    upsellsPrice,
    breakdown: cpqResult.breakdown || [],
    autoIncludeItems: cpqResult.autoIncludeItems || [],
    shownRules: cpqResult.shownRules || [],
    hiddenRules: cpqResult.hiddenRules || [],
  });
}

/**
 * Price one configured product in the browser, as the Nuxt configurator does.
 * `product` is the configurator product (GET /public/products/:id shape).
 */
export function priceConfiguredProduct(product, configuration = {}) {
  const cpqResult = useCPQPriceCalculator(
    {},
    { 'selected-product': product, 'product-selection-element': product?.id, ...configuration },
    { type: 'configurator' }
  );
  return {
    cpqResult,
    pricing: buildConfiguredPricingSnapshot(cpqResult, product, configuration),
  };
}
